export default "__VITE_ASSET__BNSy6F1N__"